(function () {
  function initStickyAtcSuppression() {
    const stickyBar = document.querySelector(".product-quick-add--sticky-bar");
    if (!stickyBar) {
      return;
    }

    const atcBlocks = document.querySelectorAll("[data-hide-sticky-atc]");
    if (!atcBlocks.length) {
      return;
    }

    const blockStates = new Map();

    const updateSuppressed = () => {
      const anyVisible = [...blockStates.values()].some(Boolean);
      document.documentElement.classList.toggle("sticky-atc-suppressed", anyVisible);
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          blockStates.set(entry.target, entry.isIntersecting);
        });
        updateSuppressed();
      },
      { threshold: 0.1 }
    );

    atcBlocks.forEach((block) => {
      blockStates.set(block, false);
      observer.observe(block);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initStickyAtcSuppression);
  } else {
    initStickyAtcSuppression();
  }
})();

